import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { TestType } from "types/testType";

const DEFAULT_TEST_TYPE = TestType.FOB;

export interface TestParams {
  testType: TestType;
  sessionId: string | null;
}

interface TestState {
  params: TestParams;
}

const initialState: TestState = {
  params: {
    testType: DEFAULT_TEST_TYPE,
    sessionId: null,
  },
};

const testSlice = createSlice({
  name: "test",
  initialState,
  reducers: {
    setTestType: (state, action: PayloadAction<TestParams>) => {
      state.params = action.payload;
    },
  },
});

export const { setTestType } = testSlice.actions;

/**
 * Get full test params object (testType and sessionId)
 */
export const getTestType = (state: RootState): TestParams => 
  state.test.params || { testType: DEFAULT_TEST_TYPE, sessionId: null };

/**
 * Get just the testType value (for backward compatibility)
 */
export const getTestTypeValue = (state: RootState): TestType => 
  getTestType(state).testType || DEFAULT_TEST_TYPE;

/**
 * Get just the sessionId value
 */
export const getSessionId = (state: RootState): string | null => 
  getTestType(state).sessionId || null;

export default testSlice;



